<template>
  <div>
    <Header></Header>
    <Clock class="clock" location="Tokyo" :diff="0"/>
    <Clock class="clock" id="ny" location="NY" :diff="-14"></Clock>
    <Clock class="clock" id="la" location="LA" :diff="-17"></Clock>
    <Clock class="clock" id="uk" location="UK" :diff="-9"></Clock>
    <Clock class="clock" id="br" location="BRAZIL" :diff="-12"></Clock>
    <Clock class="clock" id="sy" location="SYDNEY" :diff="1"></Clock>
    <Clock class="clock" id="du" location="DUBAI" :diff="-5"></Clock>
    <Clock class="clock" id="jo" location="JOHANNESBURG" :diff="-7"></Clock>
    <Footer></Footer>
  </div>
</template>

<script>
import Clock from "@/components/Clock"
import Header from "@/components/Header"
import Footer from "@/components/Footer"
export default{
  components:{
    Header,Clock,Footer,
  },
}
</script>

<style scoped>
  .clock{
    width: 80%;
    max-width: 500px;
    margin:30px auto;
  }
</style>
<style>
  html{
    font-size: 62.5%;
  }
  body{
    margin: 0;
  }
  p{
    margin: 0;
  }
</style>

